export default "__VITE_ASSET__BKXQZ25___"